import {Component, Input, OnInit} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'db-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: true,
  imports: [
    NgStyle
  ]
})
export class ProgressBarComponent implements OnInit {

  @Input() size: ''|'sm'|'m';
  @Input() state: 'info'|'success'|'warning'|'error'|'danger'|'gradient'|'black'|'purple-blue'|'gray';
  @Input() progressPercent: number;
  @Input() color: string;
  @Input() width?: string;

  constructor() {}

  ngOnInit(): void {
    this.state = this.state || 'info';
  }

}
